import { createContext } from 'react';
import { StoryDetailContextType } from '#advertStory/detail';

const StoryDetailContext = createContext<StoryDetailContextType>(null);

export { StoryDetailContext };
